import { createStyles } from "@material-ui/core";

const Styles = createStyles({});

export default Styles;
